module.exports = __webpack_public_path__ + "static/media/nownownow.d89c1ba1.wav";